// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1wcWd","left":"InfoRow_left___v-Hk"};